import { render, staticRenderFns } from "./OriginsScroller.vue?vue&type=template&id=743e4926&scoped=true"
import script from "./OriginsScroller.vue?vue&type=script&lang=ts"
export * from "./OriginsScroller.vue?vue&type=script&lang=ts"
import style0 from "./OriginsScroller.vue?vue&type=style&index=0&id=743e4926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743e4926",
  null
  
)

export default component.exports